/**
 * Adzuki.visual_list
 */

(function VisualList($, Adzuki)
{
	"use strict";

	// #modalWindow specifically, NOT $('.modal') — see editor.js. The Trip Summary
	// builder page has a second modal (#ts-component-modal) that a bare .modal
	// selector would also show, stacking it on top of the visual list.
	var $modal          = $('#modalWindow'),
		search_category = '',
		search_string   = '';

	$(document).ready(function documentReady()
	{
		// SET-32: EVERY BINDING MOVED INTO init(), AND THIS ONLY DECIDES WHETHER TO CALL IT.
		//
		// The handlers that make a selection stick - the picker's own click, and the three
		// delegated off the modal - used to be bound HERE, behind this same guard. Markup that
		// arrives after document ready therefore got a link that opened the picker and a picker
		// whose options did nothing: no value written back, and no modal close.
		//
		// The My Settings modal is the first caller to inject one (SET-32, the LivePlanner video
		// background), and it calls Adzuki.VisualList.init() after each panel render.
		if ($('.visual-list').length > 0 || $('.visual-list-selector').length > 0) {
			VisualList.init();
		}
	});

	VisualList.init = function init()
	{
		var selected_option;

		// NAMESPACED, AND off BEFORE on. init() runs once per panel render inside the My Settings
		// modal, and these three are delegated from an element that SURVIVES every render - so
		// without the namespace each render would stack another copy and one click would write the
		// value N times. The opener below is bound to the elements themselves, which are replaced
		// with the panel, but it is namespaced too rather than relying on that.
		//
		// $modal IS RE-READ HERE rather than trusted from script load: it was captured when this
		// file ran, which is before anything the modal injects exists.
		$modal = $('.modal');

		$modal.off('.visualList');

		$modal.on('change.visualList', '#visual-list-category', function searchImagesByCategory(e) {
			var image_category = '';

			// get the selected value
			search_category = $('#visual-list-category').val();

			if (search_category.length) {
				$('.visual-list-item').each(function searchImagesByCategory() {
					image_category = String($(this).data("category-id"));

					if (image_category !== undefined) {
						if (image_category === search_category) {
							$(this).removeClass('hidden d-none');
						} else {
							$(this).addClass('hidden d-none');
						}
					}
				});
			} else {
				$('.visual-list-item').removeClass('hidden d-none');
			}
		});

		$modal.on('keyup.visualList', '#visual-list-search', function searchImages(e) {
			var image_name = '';

			if (e.which === 13 ) {
				e.preventDefault();
			} else {
				search_string = $('#visual-list-search').val().toLowerCase();
			}

			if (search_string.length) {
				$('.visual-list-item').each(function searchImages() {
					image_name = $(this).data("name");

					if (image_name !== undefined) {
						image_name = image_name.toLowerCase();

						if (image_name.indexOf(search_string) === -1) {
							$(this).addClass('hidden d-none');
						} else {
							$(this).removeClass('hidden d-none');
						}
					}
				});
			} else {
				$('.visual-list-item').removeClass('hidden d-none');
			}
		});

		$modal.on('click.visualList', '.visual-list-container .select-image', function selectImage(e) {
			var $image_id     = $(this).data("id"),
				select_box_id = $(this).data("select"),
				src           = $(this).data("src");

			e.preventDefault();

			$('.visual-list > .active').each(function removeActive() {
				$(this).removeClass('active');
			});

			$(this).parents('.visual-list-item').addClass('active');

			if (src) {
				$('#visual_list_preview').attr('src', src);
				$('#visual_list_preview').removeClass('hidden');
			}

			$modal.modal('hide');

			$('#' + select_box_id).val($image_id);
			$('#' + select_box_id).trigger('change');
		});

		$modal.on('submit.visualList', '#visual_list_form', function stopFormSubmit(e) {
			e.preventDefault();
		});

		$('.visual-list-selector').off('change.visualList').on('change.visualList', function visualListSelectboxChanged() {
			var image_src;

			selected_option = $(this).find('option:selected');
			image_src       = selected_option.data('url');

			if (image_src) {
				$('#visual_list_preview').removeClass('hidden');
				$('#visual_list_preview').attr('src', image_src);
			} else {
				$('#visual_list_preview').addClass('hidden');
				$('#visual_list_preview').attr('src', null);
			}
		});

		$('.visual-list').off('click.visualList').on('click.visualList', function visualListClicked(e) {
			var $self              = $(this),
				controller         = $self.data('controller'),
				action             = $self.data('action'),
				select_box         = $self.data('select-box'),
				currently_selected = $('#' + select_box).val();

			e.preventDefault();

			Adzuki.Ajax.get('/' + controller + '/' + action + '/' + select_box).then(function success(response) {
				$modal.addClass('wide');
				$modal.find('.modal-title').text('Visual List');
				$modal.find('.modal-body').html(response);

				$('.visual-list-item').each(function highlightBasedOnSelect() {
					if (parseInt($(this).data("id")) === parseInt(currently_selected)) {
						$(this).addClass('active');
					}
				});

				search_string = '';
				$modal.modal('show');
			});
		});
	};

	Adzuki.VisualList = VisualList;
}(jQuery, window.Adzuki || {}));
